import { render, staticRenderFns } from "./InstitutionMobileView.vue?vue&type=template&id=5fa56bbf"
import script from "./InstitutionMobileView.vue?vue&type=script&lang=js"
export * from "./InstitutionMobileView.vue?vue&type=script&lang=js"
import style0 from "./InstitutionMobileView.vue?vue&type=style&index=0&id=5fa56bbf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports